import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { LeaderCriteriaResponse } from "~pages/LeaderCriteria/types/leaderCriteria.ts";
import type { UpdateLeaderCriteriaModel } from "~pages/LeaderCriteria/types/leaderCriteriaModel.ts";

export const useUpdateLeaderCriteria = () => {
  const { sport, organizationId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();

  return useMutation<LeaderCriteriaResponse, Error, UpdateLeaderCriteriaModel>({
    mutationFn: async ({ leaderCriteriaId, ...body }) =>
      await request<LeaderCriteriaResponse>(`${sport}/o/${organizationId}/statistics/leaders/criteria/${leaderCriteriaId}`, {
        method: "PUT",
        body,
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["leaderCriteria", sport, organizationId] });
    },
  });
};
